var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail, e-mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 5H3.75V15H16.25V5ZM5 6.90287V13.75H15V6.90288L10 10.7918L5 6.90287ZM13.8034 6.25H6.19662L10 9.20819L13.8034 6.25Z",
    fill: "#303315"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/e-mail.aa9a8ea4b8c41e3bcea8bf5530f24e44.svg";
export { ForwardRef as ReactComponent };